// import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";

export default (query, uri) => {
  const fetch = query;
  const { loading, error, data } = useQuery(fetch, {
    variables: {
      uri
    },
    notifyOnNetworkStatusChange: true
  });

  return {
    loading,
    error,
    data
  };
};